// components/ModalActions.tsx
import { CloseIcon } from '@/assets';
import { Button } from '@/atoms';
import { ButtonType } from '@/types';

import styles from './styles.module.scss';

interface ModalTitleActionsProps {
  onClose: () => void;
  onSave?: () => void;
}

export const ModalTitleActions: React.FC<ModalTitleActionsProps> = ({ onClose, onSave }) => (
  <div className={styles.buttonsWrapper}>
    {onSave && (
      <Button type={ButtonType.Primary} className={styles.saveBtn} onClick={onSave}>
        Готово
      </Button>
    )}
    <div className={styles.close} onClick={onClose}>
      <CloseIcon className={styles.closeIcon} />
    </div>
  </div>
);
